<template>
  <base-form-detail
    :controller="controller"
    :readonly="readonly"
    :source="source"
    @close="$emit('close')"
    @save="$emit('save')"
  >
    <entity-card-e-mail-detail
      :codes="contentMixin.codes"
      :readonly="readonly"
      :source="source"
    />
  </base-form-detail>
</template>

<script>
import BaseFormDetail from '@/components/shared/base/base-form-detail'
import BaseFormDetailMixin from '@/mixins/base-form-detail-mixin'
import EntityCardEMailDetail from '@/components/shared/entitycards/entity-card-e-mail-detail'

export default {
  name: 'EMailDetail',
  components: {
    BaseFormDetail,
    EntityCardEMailDetail
  },
  mixins: [
    BaseFormDetailMixin
  ],
  data () {
    return {
      controller: 'Mail'
    }
  },
  mounted () {
    this.Initialize()
  },
  methods: {
    async Initialize () {
      await this.BaseFormDetailMixin_Initialize(this.controller)
    }
  }
}
</script>
